import React from "react";
import { useTranslation } from "react-i18next";
import "./AvatarOptionsModal.less";

export type AvatarOptionsModalProps = {
  onClose: () => void;
  onEdit: () => void;
  onDelete: () => void;
  isDeleteDisabled: boolean;
};

const AvatarOptionsModal: React.FC<AvatarOptionsModalProps> = ({ onClose, onEdit, onDelete, isDeleteDisabled }) => {
  const { t } = useTranslation();

  const handleOverlayClick = () => onClose?.();
  const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => e.stopPropagation();

  const modalContent = (
    <div className="avatar-options-modal-overlay" onClick={handleOverlayClick}>
      <div className="avatar-options-modal-content" onClick={handleModalClick}>
        <div className="modal-header-line-wrapper">
          <div className="modal-header-line"></div>
        </div>

        <div className="avatar-options-modal-container">
          <div className="avatar-options-modal-title">{t("what-action-do-you-want-to-take")}</div>

          <button type="button" className="avatar-options-modal-button" onClick={onEdit}>
            {t("edit-avatar")}
          </button>

          <button
            type="button"
            className="avatar-options-modal-button"
            onClick={onDelete}
            disabled={isDeleteDisabled}
            style={{ opacity: isDeleteDisabled ? 0.5 : 1, cursor: isDeleteDisabled ? "not-allowed" : "pointer" }}
          >
            {t("delete-avatar")}
          </button>

          <button type="button" className="avatar-options-modal-cancel-button" onClick={onClose}>
            {t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );

  return modalContent;
};

export default AvatarOptionsModal;
